<template>
	<div>
		<div class="white-bg tsfx">
			<div class="content  ">
				<div class="title u-text-center ">精选作品</div>
				<div class="u-text-center title_tips">顶尖设计作品聚集地</div>

				<div class="tab-con">
					<div class="jxzp ">
						<div class="jxzp-c " v-for="(item,index) in list" :key="index" @click="toDetails(item.workId)">
							<div class="s_list_img ">
								<el-image fit="cover" :src="item.picture" />
							</div>
							<div class="t_n">
								<h2>{{item.title}} </h2>
								<div class="mores">
									<span v-for="(items,indexs) in item.tags.split(',').slice(0,3)">{{items}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="u-text-center btn_box">
				<button class="home_btn" @click="moreWork">查看更多作品<i class="el-icon-arrow-right"></i></button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'selectedworks',
		components: {},
		data() {
			return {
				list: null
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			async getlist() {
				const res = await this.$axios.get('/front/listWorks', {
					pageNum: 1,
					pageSize: 8,
					isTop: 0
				})
				this.list = res.rows
			},
			toDetails(id) {
				const {
					href
				} = this.$router.resolve({
					path: 'workdetails',
					query: {
						workId: id
					}
				})
				window.open(href, '_blank')
			},
			moreWork() {
				const {
					href
				} = this.$router.resolve({
					path: 'dismore',
				})
				window.open(href, '_blank')
			}

		}
	}
</script>
<style lang="scss" scoped>
	.btn_box {
		margin-top: 40px;
	}

	.tsfx {
		padding: 100px 0 80px 0;
	}

	.tab-con {
		margin-top: 60px;
	}

	.jxzp:after {
		content: '';
		display: block;
		clear: both;
	}

	.jxzp {
		cursor: pointer;

		.jxzp-c {
			width: 23.5%;
			overflow: hidden;
			float: left;
			margin-right: 2%;
			margin-bottom: 2%;
			background-color: var(--white);
			position: relative;
			border-radius: 10px;

			.s_list_img {
				.el-image {
					width: 100%;
					height: 320px;
					object-fit: cover;
				}
			}

			.t_n {
				position: absolute;
				top: 0;
				left: -100px;
				bottom: 0;
				width: 56px;
				background-color: var(--brand);
				writing-mode: vertical-rl;
				padding: 30px 20px;
				line-height: 1.8;
				color: var(--white);
				letter-spacing: 4px;
				transition-duration: .4s;

				.mores {
					margin-right: 4px;

					span {
						border: 1px solid rgba(255, 255, 255, .4);
						padding: 6px 4px 2px 4px;
						border-radius: 8px;
						margin-bottom: 10px;
					}
				}

				.lkitem {
					display: none;

					span {
						background-color: var(--info);
						padding: 10px 0;
						display: inline-block;
						margin-right: 4px;
						border-radius: 4px;
						color: var(--white);
					}
				}

				&:hover .lkitem {
					display: block;
				}
			}

			&:hover .t_n {
				left: 0px;
			}
		}

		.jxzp-c:nth-child(4n) {
			margin-right: 0;
		}
	}
</style>
